import * as React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon/Icon";

const Branch: React.FC = () => {
    return (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M23.0037 0H1.99631C0.675676 0 0 0.657895 0 1.97368V7.23684C0 8.55263 0.675676 9.21053 1.99631 9.21053V23.6842C1.99631 24.3421 2.7027 25 3.37838 25H21.6216C22.2973 25 23.0037 24.3421 23.0037 23.75V9.21053C24.3243 9.21053 25 8.55263 25 7.23684V1.97368C25 0.657895 24.3243 0 23.0037 0ZM1.99631 6.57895V2.63158C1.99631 2.30263 2.36486 1.97368 2.7027 1.97368H22.2973C22.6351 1.97368 23.0037 2.30263 23.0037 2.63158V6.57895C23.0037 6.90789 22.6536 7.23684 22.2973 7.23684H2.7027C2.36486 7.23684 1.99631 6.90789 1.99631 6.57895ZM14.8342 23.0263H10.1658V17.5C10.1658 16.125 11.2162 15 12.5 15C13.7838 15 14.8342 16.125 14.8342 17.5V23.0263ZM20.9459 23.0263H16.8919V17.5C16.8919 14.7375 15.0792 13.1579 12.5 13.1579C9.92076 13.1579 8.10811 14.7375 8.10811 17.5V23.0263H4.05405V9.21053H20.9459V23.0263Z"
                fill="#002856"
            />
        </svg>
    );
};

export default React.memo(Branch);
